import React, { useEffect, useRef } from "react";
import { Paper, Typography, Grid, Box, Divider } from "@mui/material";

const ChatBox = ({ messages, notRole }) => {
  const messageContainerRef = useRef();
  useEffect(() => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop =
        messageContainerRef.current.scrollHeight;
    }
  }, [messages]);
  return (
    <Paper elevation={1} style={{ marginTop: "15px", height: "40vh" }}>
      <Box textAlign={"center"}>
        <p>Conversation Box</p>
        <Divider />
      </Box>

      <Box p={"15px"} height="30vh" overflow={"auto"} ref={messageContainerRef}>
        {messages &&
          messages.map((message, index) => (
            <div key={index} style={{ marginBottom: "16px" }}>
              <Grid
                container
                justifyContent={
                  message.sender === notRole ? "flex-start" : "flex-end"
                }
                textAlign={message.sender === notRole ? "left" : "right"}
              >
                <Grid item>
                  <Paper
                    elevation={3}
                    style={{
                      backgroundColor: `${
                        message.sender === notRole ? "white" : "blue"
                      }`,
                      color: `${
                        message.sender === notRole ? "black" : "white"
                      }`,
                      padding: "8px",
                      position: "relative",
                      borderRadius: "12px",
                      // maxWidth: "80%",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "5px",
                        padding: "0px 5px",
                      }}
                    >
                      <Typography variant="body1">{message.content}</Typography>
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        position: "absolute",
                        bottom: "0",
                        right: "5px",
                      }}
                    >
                      {new Date(message.createdAt).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </Paper>
                </Grid>
              </Grid>
            </div>
          ))}
      </Box>
    </Paper>
  );
};

export default ChatBox;
